import useApi from '../../../services/useApi'
import useFilters from '../../../hook/useFilters'
import moment from 'moment'
import {useState} from 'react'

const useGetBrandsWithPurchasersReport = () => {
  const [dateRange] = useState(() => JSON.parse(localStorage.getItem('selectedDateRange') || '{}'))
  const Api = useApi()

  const initialFilters = {
    page: 1,
    limit: 50,
    search: '',
    sort_by: 'total_profit/-1',
    start_date: dateRange?.startDate ?? moment().subtract(3, 'months').format('YYYY-MM-DD'),
    end_date: dateRange?.endDate ?? moment().format('YYYY-MM-DD'),
    brand_ids: '',
    purchaser_ids: '',
  }

  const {filters, onSearch, onSortingChange, onPageChange, onDateChange, setMultipleFilters} =
    useFilters(initialFilters, {sortType: 'number'})

  const {data: response, isFetching} = Api.useGetQuery('/analytics/profitability/brands', {
    queryId: 'brands-with-purchasers-report',
    filters,
    isToast: false,
    isErrorPageRedirection: false,
  })

  const onChangeBrandFilter = (values: any[]) => {
    setMultipleFilters({
      brand_ids: values?.map((item) => item.value).join(','),
      page: 1,
    })
  }

  const onChangePurchaserFilter = (values: any[]) => {
    setMultipleFilters({
      purchaser_emails: values?.map((item) => item.value).join(','),
      page: 1,
    })
  }

  const onDownloadCSV = async () => {
    const {page, limit, ...restFilters} = filters
    const response: any = await Api.get('/analytics/profitability/brands/csv', {
      filters: restFilters,
    })
    return {
      message: response?.data?.message,
      status: response?.status,
    }
  }

  return {
    reportData: response?.data || [],
    pagination: response?.meta?.pagination || {},
    isLoading: isFetching,
    filters,
    onSearch,
    onSortingChange,
    onPageChange,
    onDateChange,
    onChangeBrandFilter,
    onChangePurchaserFilter,
    onDownloadCSV,
  }
}

export default useGetBrandsWithPurchasersReport
